<template>
  <div>
    <c-wrapper
      v-for="(counter, index) in counters"
      :key="index"
      :counter="counter"
      :name="counter.name"
    ></c-wrapper>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CWrapper from "@/components/CWrapper";

export default {
  components: {
    CWrapper
  },
  computed: {
    ...mapState({
      counters: (state) => state.admin.counters,
    }),
  },
};
</script>

<style scoped></style>
